import { SINGLE_VIEW_LAYOUTS } from '../constants/layout';

// True for layouts that render one product at a time (single-product carousel) —
// skip promotion padding and impress only the visible product at mount. Mirrors
// widget-ssr's isSingleViewLayout (@klickly/boa-awa-core).
export const isSingleViewLayout = (layout) => SINGLE_VIEW_LAYOUTS.has(layout);
